import React from 'react';
import SelectFilter from './SelectFilter';

const PackageFilter = ({ selectedPackage, setSelectedPackage, availablePackages, loading }) => {
  // Show loading state or empty array until packages are loaded
  const options = loading ? ['Loading packages...'] : availablePackages;
  
  return (
    <SelectFilter 
      options={options} 
      selectedValue={loading ? 'Loading packages...' : selectedPackage} 
      setSelectedValue={loading ? () => {} : setSelectedPackage}
    />
  );
};

export default PackageFilter; 